import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_669_10272)\"><path d=\"M6 11C8.76143 11 11 8.76143 11 6C11 3.23857 8.76143 1 6 1C3.23857 1 1 3.23857 1 6C1 8.76143 3.23857 11 6 11Z\" fill=\"#F55953\" stroke=\"#F55953\" stroke-width=\"1.83333\" stroke-linejoin=\"round\"></path><path d=\"M4 6H8\" stroke=\"white\" stroke-width=\"1.83333\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_669_10272\"><rect width=\"12\" height=\"12\" fill=\"white\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }